import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Activity, Stethoscope, Pill, ClipboardList, Wind, Baby, LogOut, Syringe, Droplet, FlaskConical } from "lucide-react";
import { fmtLocalDT } from "@/lib/clinical";

const ICONS = {
  admission: Baby,
  discharge: LogOut,
  vitals: Activity,
  medication_order: Pill,
  medication_given: Syringe,
  investigation: FlaskConical,
  ventilator: Wind,
  fluid: Droplet,
  procedure: Stethoscope,
  transfer: ClipboardList,
};

export default function TimelineTab({ patient }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get(`/patients/${patient.id}/timeline`).then(({ data }) => setItems(data)).catch(() => {});
  }, [patient.id]);

  return (
    <div className="card-clinical p-6" data-testid="timeline-tab">
      <div className="text-xs uppercase tracking-widest text-muted-foreground mb-4">Chronological activity</div>
      <div className="relative">
        <div className="absolute left-[10px] top-2 bottom-2 w-px bg-border" />
        <ul className="space-y-4">
          {items.length === 0 && <li className="text-sm text-muted-foreground">No events yet.</li>}
          {items.map((e) => {
            const Icon = ICONS[e.kind] || Activity;
            return (
              <li key={e.id} className="relative pl-8">
                <span className="absolute left-0 top-0 h-6 w-6 rounded-full bg-primary/10 grid place-items-center text-primary">
                  <Icon size={12} />
                </span>
                <div className="flex items-baseline justify-between gap-3">
                  <div className="font-medium text-sm">{e.text}</div>
                  <div className="text-[11px] text-muted-foreground tabular">{fmtLocalDT(e.at)}</div>
                </div>
                <div className="text-xs text-muted-foreground">by {e.by}</div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
